import {
  getData,
  postData,
  getDataCache,
  getFileData
} from './api-base.service'

export const getSpeedupCourseSummary = (termId, planId, universityGroupNumber) => {
  let data = {
    PlanId: planId,
    TermId: termId,
    UniversityGroupNumber: universityGroupNumber
  };
  var result = postData('/SpeedupCourse/GetSpeedupCourse', data);
  return result;
}

export const addSpeedupCourseSchedulePlan = (termId, universityGroupNumber, campusId) => {
  let data = {
    termId: termId,
    universityGroupNumber: universityGroupNumber,
    campusId: campusId
  };
  var result = getData('/SpeedupCourse/AddPlan', data);
  return result;
}

export const getSpeedupCoursePlans = (termId, universityGroupNumber, campusId) => {
  let data = {
    termId: termId,
    universityGroupNumber: universityGroupNumber,
    campusId: campusId
  };
  var result = getData('/SpeedupCourse/GetPlans', data);
  return result;
}

export const getSpeedupCourseTotalCount = (termId, planId) => {
  let data = {
    termId: termId,
    planId: planId
  };
  var result = getData('/SpeedupCourse/GetTotalCourseCount', data);
  return result;
}

export const getPlanCourseList = (termId, planId, teacherId = 0, isGetAll = false) => {
  let data = {
    termId: termId,
    planId: planId,
    teacherId: teacherId,
    isGetAll: isGetAll
  };
  var result = getData('/Course/GetPlanCourseList', data);
  return result;
}

//获取选中的某一门课的课程安排
export const getSpeedupCourseSchedule = (termId, planId, courseId, teacherId, courseClass) => {
  let data = {
    termId: termId,
    planId: planId,
    courseId: courseId,
    teacherId: teacherId,
    courseClass: courseClass
  };
  var result = getData('/SpeedupCourse/GetSpeedupCourseSchedule', data);
  return result;
}

export const getAvailableCourse = (termId, planId, courseWithTeacherList, dayOfWeek, startTime, endTime) => {
  let data = {
    TermId: termId,
    PlanId: planId,
    CourseWithTeacherList: courseWithTeacherList,
    DayOfWeek: dayOfWeek,
    StartTimeText: startTime,
    EndTimeText: endTime
  };
  var result = postData('/SpeedupCourse/GetAvailableCourse', data);
  return result;
}

export const saveSpeedupCourse = (planId, courseWithTeacherList, dayOfWeek, startTime, endTime) => {
  let data = {
    PlanId: planId,
    CourseWithTeacherList: courseWithTeacherList,
    DayOfWeek: dayOfWeek,
    StartTimeText: startTime,
    EndTimeText: endTime
  };
  var result = postData('/SpeedupCourse/SaveSpeedupCourse', data);
  return result;
}

export const removeSpeedupPlan = (planId) => {
  let data = {
    id: planId
  };
  var result = getData('/SpeedupCourse/RemoveSpeedupPlan', data);
  return result;
}

export const deleteSpeedupCourse = (scheduleId) => {
  let data = {
    scheduleId: scheduleId,
  };
  var result = getData('/SpeedupCourse/DeleteSpeedupCourse', data);
  return result;
}

export const separateCourse = (termId, planId, courseId, teacherId, courseClass, studentIds) => {
  let data = {
    TermId: termId,
    PlanId: planId,
    CourseId: courseId,
    TeacherId: teacherId,
    CourseClass: courseClass,
    Percentage: 0,
    UnavailableStudentList: studentIds
  };
  var result = postData('/SpeedupCourse/SeparateCourse', data);
  return result;
}

export const getScheduleStudentList = (termId, planId, courseId, teacherId, courseClass) => {
  let data = {
    termId: termId,
    planId: planId,
    courseId: courseId,
    teacherId: teacherId,
    courseClass: courseClass,
  };
  var result = getData('/SpeedupCourse/GetScheduleStudentList', data);
  return result;
}

export const removeSeparateCourse = (planId, courseId, teacherId, courseClass) => {
  let data = {
    PlanId: planId,
    CourseId: courseId,
    TeacherId: teacherId,
    CourseClass: courseClass
  };
  var result = postData('/SpeedupCourse/RemoveSeparateCourse', data);
  return result;
}

export const compareCourse = (termId, planId, course1, course2) => {
  let data = {
    TermId: termId,
    PlanId: planId,
    Course1: {
      CourseId: course1.courseId,
      TeacherId: course1.teacherId,
      CourseClass: course1.courseClass
    },
    Course2: {
      CourseId: course2.courseId,
      TeacherId: course2.teacherId,
      CourseClass: course2.courseClass
    }
  };
  var result = postData('/SpeedupCourse/CompareCourse', data);
  return result;
}

export const verifyPlan = (termId, planId) => {
  let data = {
    termId: termId,
    planId: planId
  }
  var result = getData('/SpeedupCourse/Verify', data);
  return result;
}

export const getMoreThanOneCourseData = (termId, planId) => {
  let data = {
    termId: termId,
    planId: planId
  }
  var result = getData('/SpeedupCourse/GetMoreThanOneCourseData', data);
  return result;
}

export const selectPlan = (planId, universityGroupNumber, campusId) => {
  let data = {
    planId: planId,
    universityGroupNumber: universityGroupNumber,
    campusId: campusId
  };
  var result = getData('/SpeedupCourse/SelectPlan', data);
  return result;
}

export const getCoursesInTerm = (termId, universityGroup, courseType) => {
  let data = {
    termId,
    universityGroup,
    courseType
  };
  var result = getData('/SpeedupCourse/GetCoursesInTerm', data);
  return result;
}

export const downloadTemplate = () => {
  let result = getFileData('/SpeedupCourse/DownloadTemplate');
  return result;
}

export const getSpeedupCourseList = (universityGroup, searchKey, yearCourseType) => {
  let data = {
    universityGroup: universityGroup,
    searchKey: searchKey,
    yearCourseType: yearCourseType
  };
  var result = getData('/SpeedupCourse/GetSpeedupCourseList', data);
  return result;
}

export const saveSpeedupCourseList = (id, name, universityGroup, courseCode, professorName, courseMinutes,
  universityList, campusList, isFreeVideo, isCheckCamera, isYearCourse, startMonth, endMonth, contractId,
  courseBasicCategory, courseClassGrade, courseCategory, hasOwnDevice, videoAppointmentAll, courseReplayRuleId) => {
  let data = {
    id: id,
    name: name,
    universityGroup: universityGroup,
    CourseCode: courseCode,
    ProfessorName: professorName,
    CourseMinutes: courseMinutes,
    UniversityList: universityList,
    CampusList: campusList,
    isFreeVideo: isFreeVideo,
    isCheckCamera: isCheckCamera,
    isYearCourse: isYearCourse,
    startMonth: startMonth,
    endMonth: endMonth,
    ContractId: contractId,
    CourseBasicCategory: courseBasicCategory,
    CourseClassGrade: courseClassGrade,
    CourseCategory: courseCategory,
    hasOwnDevice: hasOwnDevice,
    videoAppointmentAll: videoAppointmentAll,
    CourseReplayRuleId: courseReplayRuleId
  }
  return postData('/SpeedupCourse/SaveSpeedupCourseList', data);
}

export const disableSpeedupCourse = (courses) => {
  return postData("/SpeedupCourse/DisableSpeedupCourseList", courses);
}

export const batchSetSpeedUpCourseList = (courses) => {
  return postData("/SpeedupCourse/BatchSetSpeedUpCourseList", courses);
}

export const batchSetContract = (courseIds, contractId) => {
  let data = {
    courseIds,
    contractId
  };
  return postData("/SpeedupCourse/BatchSetContract", data);
}

export const validateStudentByPhone = (phone) => {
  let data = {
    phone: phone
  };
  let result = getData('/CourseApply/ValidateStudentByPhone', data);
  return result;
}

export const getStudentSpeedupCourseList = (phone) => {
  let data = {
    phone: phone
  };
  let result = getData('/CourseApply/GetStudentSpeedupCourseList', data);
  return result;
}

export const getCurrentTerm = () => {
  let result = getData('/CourseApply/GetCurrentTerm');
  return result;
}

export const getCurrentNextTerms = (termType, trainingCategoryId, isCache) => {
  if (!termType) {
    termType = 1;
  }
  if (!trainingCategoryId) {
    trainingCategoryId = 0;
  }
  let data = {
    termType: termType,
    trainingCategoryId: trainingCategoryId
  };
  let result = getDataCache('/CourseApply/GetCurrentNextTerms', data, isCache);
  return result;
}

export const getCourses = (groupNumber) => {
  let result = getData('/CourseApply/GetCourses', {
    universityGroup: groupNumber
  });
  return result;
}

export const getCoursesWithTerm = (termId, groupNumber, hasPrice) => {
  let result = getData('/CourseApply/GetCoursesWithTerm', {
    termId: termId,
    universityGroup: groupNumber,
    hasPrice: hasPrice
  });
  return result;
}

export const getTrainingCourses = (termId, categoryId) => {
  let result = getData('/CourseApply/GetTrainingCourses', {
    termId: termId,
    categoryId: categoryId
  });
  return result;
}

export const getTeacherByCourseId = (courseId) => {
  let data = {
    courseId: courseId
  };
  let result = getData('/CourseApply/GetTeacherByCourseId', data);
  return result;
}

export const saveStudentSpeedupCourse = (studentId, data) => {
  let result = postData('/CourseApply/SaveStudentSpeedupCourse?studentId=' + studentId, data);
  return result;
}

export const getSpeedupCoursePrice = (universityGroup, courseName) => {
  let data = {
    universityGroup: universityGroup,
    courseName: courseName
  };
  let result = getData('/Finance/GetPrices', data);
  return result;
}

export const getTrainingCurrentNextTerms = (isCache) => {
  let result = getDataCache('/CourseApply/GetTrainingCurrentNextTerms', null, isCache);
  return result;
}

export const getAllTrainingEnglishCourses = () => {
  let result = getData('/CourseApply/GetAllTrainingEnglishCourses');
  return result;
}

export const getTeacherList = (categoryId) => {
  let data = {
    categoryId: categoryId
  };
  let result = getData('/CourseApply/GetTeacherList', data);
  return result;
}

export const getStudentByCourse = (courseId, teacherId, campusId) => {
  let data = {
    courseId: courseId,
    teacherId: teacherId,
    campusId: campusId
  };
  let result = getData('/CourseApply/GetStudentByCourse', data);
  return result;
}

export const getYearCourseTypeWithWeek = (courseId) => {
  let data = {
    courseId: courseId
  };
  let result = getData('/CourseApply/GetYearCourseTypeWithWeek', data);
  return result;
}

export const getCourseAssureScore = (courseId, yearCourseType) => {
  if (yearCourseType == "") {
    yearCourseType = 0;
  }
  let data = {
    courseId: courseId,
    yearCourseType: yearCourseType
  };
  let result = getData('/CourseApply/GetCourseAssureScore', data);
  return result;
}



// WEBPACK FOOTER //
// ./src/service/speedupCourse.service.js